module.exports = __webpack_public_path__ + "media/images/svgs/realestate/house-a88cfb2b8f7723189d81e3a0383354d8.svg";